










































import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { IFileWrapper, Maybe, IFile } from '@/models';
import { client } from '@/store';
import { BaseDetail } from '../Base/BaseDetail';
import { Prop } from 'vue-property-decorator';

const namespace = 'file';
const ns = { namespace };

@Component
export default class FileDetail extends BaseDetail<IFileWrapper> {
  @Prop({ default: false }) modal: boolean;
  modalPath: Maybe<string> = null;
  namespace = namespace;
  @State('entities', ns) entities: Record<string, IFileWrapper>;
  @Action('createEntity', ns) createEntity: any;
  @Action('getEntity', ns) getEntity: any;
  @Action('updateEntity', ns) updateEntity: any;
  @Action('deleteEntity', ns) deleteEntity: any;
}
